import { notification } from 'antd';

/**
 * Toasts land top-centre, not top-right.
 *
 * antd renders notifications at `zIndexPopupBase + 50`, above a Modal's own `+ 10`, so a
 * top-right toast covers the top-right corner of any open dialog — which is where its
 * close button lives. The toast is painted over it and eats the clicks, so the dialog
 * cannot be dismissed while one is on screen. Bottom-right has the same problem against
 * a dialog's primary action. Top-centre clears both: a 384px notice centred on the
 * viewport stays well inside the horizontal span of a centred dialog's controls.
 *
 * @param {import('react').ReactNode} description antd renders a string or any React node
 */
export const showNotification = (description = '', title = 'Notification', type = 'info', placement = 'top') => {
  notification[type]({
    message: title || 'Notification',
    description: description || '',
    placement,
  });
};

/** Same top-centre placement, and for the same reason — see `showNotification`. */
export const showNotificationDuration = (duration, description = '', title = 'Notification', type = 'info', placement = 'top', key) => {
  notification[type]({
    message: title || 'Notification',
    description: description || '',
    placement,
    duration,
    key,
  });
};
